import React from 'react'
import './dropdownExport.css'

export default function DropdownExport() {
    return (
        <div>
            <div className="dropdown">

                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div className="dropdown-item">(JPG) خروجی تصویر </div>
                    <div className="dropdown-item">(PNG) خروجی تصویر </div>
                    <div className="dropdown-item">Export and download PDF</div>
                    <hr />
                    <div className="dropdown-item">پرینت</div>
                </div>
            </div>
        </div>
    )
}
